import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { MESSAGE_MODALS } from '../../../context/custom/MessageModalContext';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { useEntidad } from '../../hooks/useEntidad';
import { getDateToString, getFormatNumber } from '../../../utils/convert';
import { TableCustom } from '../../common';
import { isNull } from '../../../utils/validator';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import RecargoDescuentoModal from '../RecargoDescuentoModal';
import { useManagedContext } from '../../hooks';
import {TIPS} from "../../../consts/tips";


const RecargosDescuentosGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idCuenta: 0,
      idTipoTributo: 0,
      disabled: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      dataTagger: {
          showModal: false,
          idEntidad: null
      },
      personas: [],
      list: []
  });

    const dispatch = useDispatch();
    const sequenceValue = useSelector( (state) => state.sequence.value );
    const { showMessageModal } = useManagedContext();

    const mount = () => {
        setState(prevState => {
        const list = props.data.list.filter(x => x.state !== 'r');
        return {...prevState,
            idCuenta: props.data.idCuenta,
            idTipoTributo: props.data.idTipoTributo,
            personas: props.data.personas ?? [],
            list: list };
        });
    }
    useEffect(mount, [props.data]);

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoRecargoDescuento','Tasa','SubTasa'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoRecargoDescuento_Tasa_SubTasa',
          timeout: 0
        }
    });

    const getDescTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? `${row.codigo}` : '';
      }
    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    

    const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                    <div onClick={ (event) => handleClickRecargoDescuentoAdd() } className="link">
                                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                )}
                              </div>
    const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickRecargoDescuentoView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickRecargoDescuentoModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickRecargoDescuentoRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickRecargoDescuentoDataTagger(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>   
                              </div>

    const getDescTipoRecargoDescuento = (id) => {
        const row = getRowEntidad('TipoRecargoDescuento', id);
        return (row) ? `${row.codigo} - ${row.nombre}` : '';
    }

    const tableColumns = [
        { Header: 'Tipo', Cell: (props) => getDescTipoRecargoDescuento(props.value), accessor: 'idTipoRecargoDescuento', width: '25%' },
        { Header: 'Tasa', Cell: (data) => getDescTasa(data.value), accessor: 'idTasa', width: '10%' },
        { Header: 'Sub tasa', Cell: (data) => getDescSubTasa(data.value), accessor: 'idSubTasa', width: '25%' },
        { Header: 'Valor', Cell: (props) => (props.row.original.importe === 0) ?
                                            getFormatNumber(props.row.original.porcentaje,2) + ' %' :
                                            '$ ' + getFormatNumber(props.row.original.importe,2), id: 'valor', accessor: 'id', width: '10%', alignCell: 'right' },
        { Header: 'Desde', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaDesde', width: '10%' },
        { Header: 'Hasta', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaHasta', width: '10%' },
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickRecargoDescuentoAdd = () => {
        const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
        setState(prevState => {
            const rowForm = {
                id: idTemporal,
                idCuenta: state.idCuenta,
                idTipoRecargoDescuento: 0,
                idTasa: 0,
                idSubTasa: 0,
                idRubro: 0,
                fechaDesde: null,
                fechaHasta: null,
                fechaOtorgamiento: null,
                numeroSolicitud: '',
                porcentaje: 0,
                importe: 0,
                idTipoPersona: 0,
                idPersona: 0,
                nombrePersona: '',
                idTipoDocumento: 0,
                numeroDocumento: '',
                numeroDDJJ: '',
                letraDDJJ: '',
                ejercicioDDJJ: '',
                numeroDecreto: '',
                letraDecreto: '',
                ejercicioDecreto: '',
                idExpediente: 0,
                detalleExpediente: '',
                state: 'a'
            };
            return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
        dispatch( sequenceActionNext() );
    }

    const handleClickRecargoDescuentoView = (id) => {
        setState(prevState => {
          const rowForm = state.list.find(x => x.id === id);
          return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
        });
    }

    const handleClickRecargoDescuentoModify = (id) => {
        setState(prevState => {
          const rowForm = state.list.find(x => x.id === id);
          return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
    }

    const handleClickRecargoDescuentoRemove = (id) => {
        const item = state.list.find(x => x.id === id);
        showMessageModal({
            ...MESSAGE_MODALS.BORRAR,
            message: `¿Está seguro de borrar el recargo/descuento?`,
            onConfirm: () => {
                props.onChange('RecargoDescuento', { ...item, state: 'r' });
            },
        })
    }

    const handleClickRecargoDescuentoDataTagger = (id) => {
        setState(prevState => {
          return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
        });
    }    

    // funciones
    function UpdateRecargoDescuento(row) {
        row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
        props.onChange('RecargoDescuento', row);
    }

    return (
    <>

        {state.dataTagger.showModal &&
            <DataTaggerModalRedux
                title="Información adicional de recargo descuento"
                tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_RECARGO_DESCUENTO_MODAL}
                processKey={props.processKey}
                entidad="RecargoDescuento"
                idEntidad={state.dataTagger.idEntidad}
                disabled={props.disabled}
                onDismiss={() => {
                setState(prevState => {
                    return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
                });
                }}
            />
        }

        {state.showForm && 
            <RecargoDescuentoModal
                processKey={props.processKey}
                disabled={!state.modeFormEdit}
                data={{
                    entity: state.rowForm,
                    idTipoTributo: state.idTipoTributo,
                    personas: state.personas,
                    listAll: state.list
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                }}
                onConfirm={(row) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                    UpdateRecargoDescuento(row);
                  }}
            />
        }

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={ state.list }
        />

    </>
    );
}

RecargosDescuentosGrid.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onChange: func.isRequired
  };
  
  RecargosDescuentosGrid.defaultProps = {
    disabled: false
  };

export default RecargosDescuentosGrid;
